// Servicio centralizado para manejar operaciones del perfil de usuario en Supabase.
// Maneja lecturas y escrituras del perfil con manejo explícito de errores.

import { supabase } from '../lib/supabase';

// Obtiene el perfil de usuario usando RPC.
// Parámetros: userId del usuario.
export const getUserProfile = async (userId) => {
  if (!userId) {
    throw new Error('ID de usuario requerido para obtener perfil.');
  }

  const { data, error } = await supabase.rpc('user_profile_social', {
    friend_id: userId,
  });

  if (error) {
    console.error('Error al obtener perfil:', error);
    throw error;
  }

  if (data && data.length > 0) {
    return data[0];
  } else {
    throw new Error('Perfil no encontrado.');
  }
};

// Actualiza el perfil de usuario.
// Espera userId y objeto con campos a actualizar.
export const updateUserProfile = async (userId, profileData) => {
  if (!userId) {
    throw new Error('ID de usuario requerido para actualizar perfil.');
  }
  if (!profileData || typeof profileData !== 'object') {
    throw new Error('Datos de perfil válidos requeridos.');
  }

  const { data, error } = await supabase
    .from('profiles')
    .update(profileData)
    .eq('id', userId)
    .select();

  if (error) {
    console.error('Error al actualizar perfil:', error);
    throw error;
  }

  if (data && data.length > 0) {
    return data[0];
  } else {
    throw new Error('No se pudo actualizar el perfil.');
  }
};

// Actualiza preferencias relacionadas con el perfil.
// Específicamente sex_user en preferencias.
export const updateProfilePreferences = async (userId, sexUser) => {
  if (!userId) {
    throw new Error('ID de usuario requerido para actualizar preferencias.');
  }

  const { data, error } = await supabase
    .from('preferencias')
    .update({ sex_user: sexUser })
    .eq('user_ref_id', userId)
    .select();

  if (error) {
    console.error('Error al actualizar preferencias del perfil:', error);
    throw error;
  }

  if (data && data.length > 0) {
    return data[0];
  } else {
    throw new Error('No se pudieron actualizar las preferencias.');
  }
};
